import {
  CircularProgress,
  CircularProgressProps,
  Stack,
  SxProps
} from '@mui/material';

type Props = CircularProgressProps & {
  containerSx?: SxProps;
};

export const Loading: React.FC<Props> = ({ size, sx, containerSx }) => {
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      height="100%"
      width="100%"
      data-testid="loading"
      sx={containerSx}
    >
      <CircularProgress color="primary" size={size} sx={sx} />
    </Stack>
  );
};
